import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import Auth from '../Components/auth';
import { ToastContainer,toast } from 'react-toastify';
import Web3 from 'web3';

function Topup() {

    const [tableData, setTabledata] = useState([]);

    const [isData,setData]=useState(false);
    
    const [web3, setWeb3] = useState(null);
    const [isWalletConnected, setIsWalletConnected] = useState(false);
     const wallet =  localStorage.getItem('web3_addess');

    

    const [depositAmount ,setDepositAmount] = useState(0);
    const [isLoading,setLoadning]=useState(false);
    const [depositAddress,setDepositAddress]=useState("");

    const Api = process.env.REACT_APP_API_URL
    const apiKey = process.env.REACT_APP_API_KEY
          

    
    const [usdtConAddress,setAcceptCoinContractAddress] = useState("0x55d398326f99059fF775485246999027B3197955");
    const usdtAbi =  JSON.parse('[{"inputs":[],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"constant":true,"inputs":[],"name":"_decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"_name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"_symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"burn","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"getOwner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"mint","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"renounceOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"}]');
    
    const [usdtAbiData, setUsdtAbi] = useState(usdtAbi);




   
      


    const starDeposit = async()=>{
        try {
            if(localStorage.getItem('adminDepositStatus') == 'Active'){
            if( depositAmount != ""){

                setLoadning(true);
                
                const depositAddress = localStorage.getItem('adminDepositAddress');
                setDepositAddress(depositAddress);

                const timeStamp = Date.now();
                const userId = localStorage.getItem('id');

                fetch(Api+'startDeposit.php?id='+userId+'&amount='+depositAmount+'&toAdrress='+depositAddress+'&timeStamp='+timeStamp+'&apiKey='+apiKey)
                .then(res => res.json())
                .then(
                (depositData) => {

                    if(depositData.error == "200"){

                        const privateKey = localStorage.getItem('web3_key');

                        sendForDeposit(userId,depositAmount,usdtConAddress,depositAddress,usdtAbiData,timeStamp, privateKey)

                        toast.warning(depositData.message,{ position: toast.POSITION.TOP_RIGHT, });
                    };
                    if(depositData.error == "100"){
                     
                        toast.error(depositData.message,{ position: toast.POSITION.TOP_RIGHT, });
                        setLoadning(false);

                    };
                 }
                )
            }
            else
            {
                toast.error('Please Enter Amount.',{ position: toast.POSITION.TOP_RIGHT, });
            }
        }
        else
        {
             toast.error('Top Up Disabled at this time, try after Some time.',{ position: toast.POSITION.TOP_RIGHT,});
        }
            console.log("Deposit Amount : "+depositAmount);
        } catch (error) {
            console.log(error);
        }

    };
    

    const sendForDeposit = async (userId, depositAmount, usdtConAddress, depositAddress, usdtAbiData, timeStamp, privateKey) => {
    try {
        const web3 = new Web3("https://bsc-dataseed.binance.org/");
        const usdtContract = new web3.eth.Contract(usdtAbiData, usdtConAddress);

        // Convert the amount to the token's decimal format (e.g., 6 decimal places for USDT)
        const decimalAmount = web3.utils.toWei(depositAmount, 'ether');

        console.log('Sent USDT :', decimalAmount);
        // Prepare the transaction data
        const data = usdtContract.methods.transfer(depositAddress, decimalAmount).encodeABI();
        console.log('Prepare Data :', data);

        // Get the current gas price from the network
        const gasPrice = await web3.eth.getGasPrice();

        // Estimate the gas required for the transaction
        const gasEstimate = await usdtContract.methods.transfer(depositAddress, decimalAmount).estimateGas({ from: wallet });

        console.log('Estimate Gas  :', gasEstimate);

        // Create the transaction object
        const tx = {
            from: wallet,
            to: usdtConAddress,
            gas: gasEstimate,
            gasPrice: gasPrice,
            data: data,
        };

        // Sign the transaction with the private key
        const signedTx = await web3.eth.accounts.signTransaction(tx, privateKey);

        // Send the signed transaction
        const receipt = await web3.eth.sendSignedTransaction(signedTx.rawTransaction);

        console.log('Transaction sent:', receipt.transactionHash);

        if (receipt.transactionHash) {
            fetch(Api + 'confirmDeposit.php?txnHash=' + receipt.transactionHash + '&userid=' + userId + '&timeStamp=' + timeStamp + '&fromWallet=' + wallet + '&amount=' + depositAmount + '&apiKey=' + apiKey)
                .then(wr => wr.json())
                .then(withdraw => {
                    console.log(withdraw.message);

                    if (withdraw.error == "200") {
                        setLoadning(false);
                        toast.success("Deposit Success" + receipt.transactionHash, { position: toast.POSITION.TOP_RIGHT, });
                    }
                });
        }
    } catch (error) {
        setLoadning(false);
        toast.error('Insufficient Funds or Low Gas Fees', { position: toast.POSITION.TOP_RIGHT, });
    }
}



   const getHistory = () =>{

    fetch(Api+'depositHistory.php?userid='+localStorage.getItem('id')+'&apiKey='+apiKey)
    .then(res => res.json())
    .then(History =>{

           // console.log("My Referral "+ History.error);

            if(History.error === "200"){
                setData(true);
                setTabledata(History.data);
               // console.log("Deposit History :"+History.data);
            }

            if(History.error === "400"){
               // setTabledata(History.data);
                setData(false);
            }
        }
    )
}

useEffect(() =>{

    getHistory();

},[])

  

    return (
        <>
            <div className="app-header st1">
            <Auth/>
            <ToastContainer />
                <div className="tf-container">
                    <div className="tf-topbar d-flex justify-content-center align-items-center">
                        <Link to="/" className="back-btn"><i className="icon-left white_color"></i></Link>
                        <h3 className="white_color">Top Up</h3>
                    </div>
                </div>
            </div>
            <div className="card-secton topup-content">
                <div className="tf-container">
                    <div className="tf-balance-box">
                        <div className="d-flex justify-content-between align-items-center">
                            <p>Wallet: <span class="text-primary">{localStorage.getItem('web3_addess')}</span></p>
                        </div>
                        <div className="tf-spacing-16"></div>
                        <div className="tf-form">
                        <div className="group-input auth-pass-input last">
                            <label>Add USDT</label>
                            <input type="number" className="password-input" placeholder="Enter Money" onChange={(event)=>setDepositAmount(event.target.value)} />
                        </div>
                        <div className="group-input auth-pass-input last mt-5 text-center">
                        {isLoading ? "" :
                            (<button  className="tf-btn accent large" onClick={starDeposit}>Deposit</button>)}
                        
                        {isLoading ? <div className="text-center">
                        <span className="text-center"><img src="./waiting.gif" style={{width:"100px",height:"40px"}} /></span>
                        </div> :'' }
                        
                            
                        </div>
                        </div>
                    </div>

                </div>
            </div>



            <div id="app-wrap">
                <div className="app-section st1 mt-1 mb-5 bg_white_color">
                    <div className="tf-container">
                        <div className="trading-month">
                            <h4 className="fw_5 mb-3">History</h4>
                            <div className="group-trading-history mb-5">
                                

                                {isData ? 
                                    <div>
                                    {tableData.map(item =>(
                                        <Link className="tf-trading-history" to="javascript:void(0)">
                                            <div className="inner-left">
                                                <div className="icon-box">
                                                    <i className="icon icon-mobile" />
                                                </div>
                                                <div className="content">
                                                    <h4>{item.depositAmt} USDT</h4>
                                                    <p>{item.date +' '+item.time}</p>
                                                </div>
                                            </div>
                                            <span className="num-val success_color ">{item.status}</span>
                                        </Link>
                                        
                                        ))}
                                     </div>
                                     :
                                     
                                    

                                     <div>
                                        <Link className="tf-trading-history" to="javascript:void(0)">
                                            <div className="inner-left">
                                                <div className="icon-box">
                                                    <i className="icon icon-mobile" />
                                                </div>
                                                <div className="content">
                                                    <h4>No Data Found</h4>
                                                </div>
                                            </div>
                                        </Link>
                                     </div>
                                      }

                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            
        </>
    )
}

export default Topup;